// extracted by mini-css-extract-plugin
module.exports = {"carouselArrow":"c4j1Xvh","alwaysShowButtonsOnMobile":"QY4lVE","carouselIndicators":"PChhLW","smallControls":"ziM7FL","alwaysShowButtonsOnDesktop":"pgKetm"};